import {
  $greetingsTableFilters,
  $greetingsTablePage,
  $greetingsTablePageSize,
  $greetingsTableSearch,
  $greetingsTableSort,
  type GreetingsSortState,
} from '@/entities/greetings'
import { type GetApiGreetingsQueryParams } from '@/shared/api'
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@/shared/lib/query'
import { createStore, sample } from 'effector'
import { createGate } from 'effector-react'

// Gate
export const SettingsGreetingsPageInactiveTabGate = createGate()

// Last state

// Filters
export const $settingsGreetingsPageInactiveTabLatestFilters =
  createStore<GetApiGreetingsQueryParams>({})
sample({
  source: $greetingsTableFilters,
  clock: SettingsGreetingsPageInactiveTabGate.close,
  target: $settingsGreetingsPageInactiveTabLatestFilters,
})
// Sort
export const $settingsGreetingsPageInactiveTabLatestSort =
  createStore<GreetingsSortState>({
    field: null,
    order: null,
  })
sample({
  source: $greetingsTableSort,
  clock: SettingsGreetingsPageInactiveTabGate.close,
  target: $settingsGreetingsPageInactiveTabLatestSort,
})
// Page
export const $settingsGreetingsPageInactiveTabLatestPage =
  createStore<number>(DEFAULT_PAGE)
sample({
  source: $greetingsTablePage,
  clock: SettingsGreetingsPageInactiveTabGate.close,
  target: $settingsGreetingsPageInactiveTabLatestPage,
})
// Page size
export const $settingsGreetingsPageInactiveTabLatestPageSize =
  createStore<number>(DEFAULT_PAGE_SIZE)
sample({
  clock: SettingsGreetingsPageInactiveTabGate.close,
  source: $greetingsTablePageSize,
  target: $settingsGreetingsPageInactiveTabLatestPageSize,
})
// Search
export const $settingsGreetingsPageInactiveTabLatestSearch =
  createStore<string>('')
sample({
  clock: SettingsGreetingsPageInactiveTabGate.close,
  source: $greetingsTableSearch,
  fn: (search) => search || '',
  target: $settingsGreetingsPageInactiveTabLatestSearch,
})
